import styled, { css } from 'styled-components'

export const CheckoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: ${props => props.theme.spacing.md};
  overflow: hidden;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      padding-top: 0;
    `};
`

export const CheckoutBody = styled.div`
  position: relative;
  flex: 1 1 auto;
  width: 100%;
  overflow: auto;
  mask-image: linear-gradient(to bottom, transparent, black 2rem, black);

  ${props =>
    props.theme.accessibilityMode &&
    css`
      overflow-y: auto;
    `};
`

export const CheckoutFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      bottom: ${props => props.theme.size.topBar};
    `};
`

export const CheckoutLogo = styled.div`
  ${props =>
    props.theme.accessibilityMode &&
    css`
      min-height: 50vh;
      display: flex;
      align-items: center;
    `};

  svg {
    display: block;
    height: 10rem;
    fill: ${props => props.theme.color.primary};

    ${props =>
      props.theme.contrastMode &&
      css`
        fill: ${props.theme.color.global};
      `};
  }
`
